//export default "https://auster-online-b2c-api.launchpad.com.br/";
export default "https://api.fiqueokonline.com.br/";
//export default "http://localhost:8091/";
//export default "https://api.fiqueokonline.seuapoio0800.com.br/";
